"use strict";

exports.__esModule = true;
exports.default = size;
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _keys = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return the number of elements in a collection.
function size(obj) {
  if (obj == null) return 0;
  return (0, _isArrayLike.default)(obj) ? obj.length : (0, _keys.default)(obj).length;
}